import script from "./CreateByForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateByForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateByForm.vue?vue&type=style&index=0&id=67164046&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67164046"]])

export default __exports__